import { NfzDepartment, NfzDepartmentQuery } from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';

export const useCqrsNfzDepartmentSearch = (): UseCqrsQueryResult<NfzDepartment[]> => {
   return useCqrsSearch(
      () => new NfzDepartmentQuery(),
      paginations.all<NfzDepartment>().orderedBy('code', paginations.Direction.ASCENDING)
   );
};
